module.exports = function(){
    function interval(cb, delay){
        return setInterval(cb, delay);
    }
    interval.clear = function (t) {
        return clearInterval(t);
    };
    return interval;
};



//////////////////
// WEBPACK FOOTER
// ./~/jpex-defaults/src/$interval.js
// module id = 1056
// module chunks = 0